import { type CSSProperties } from 'react';

import { observer } from 'mobx-react';

import { Overlay } from '../../components/Overlay/Overlay';
import { Tooltip } from '../../components/Tooltip/Tooltip';
import { analytics } from '../../services/analytics';
import { useStores } from '../../stores/useStores';

import { ONBOARDING_CONFIG } from './constants';
import styles from './Onboarding.module.scss';
import { SocialCoinTooltip } from './tooltips/SocialCoinTooltip';
import { SweepCoinTooltip } from './tooltips/SweepCoinTooltip';

export const CoinSwitchOnboarding = observer(
  (props: { setPopperElement: (el: HTMLElement | null) => void; tooltipStyles: CSSProperties }) => {
    const { onboardingStore, uiStore, coinTypeStore } = useStores();

    const handleSocialClick = () => {
      coinTypeStore.setCoinType('SC');
      void analytics.sendEvent('onboarding_next_step_click', {
        step: 'social_coin',
      });
      onboardingStore.nextStep();
    };

    const handleSweepClick = () => {
      uiStore.setSideMenuOpen(true);
      uiStore.setOpenFullPageDialog('redeem');
      void analytics.sendEvent('onboarding_next_step_click', {
        step: 'sweep_coin',
      });
      onboardingStore.nextStep();
    };

    return (
      <Overlay backdropClassName={styles.overlayBackdrop} className={styles.overlay}>
        <Tooltip
          arrowClassName={styles.coinSwitchArrow}
          setTooltipRef={props.setPopperElement}
          tooltipPositionStyle={props.tooltipStyles}
        >
          {onboardingStore.step === ONBOARDING_CONFIG.SOCIAL_COIN && (
            <SocialCoinTooltip handleClick={handleSocialClick} />
          )}
          {onboardingStore.step === ONBOARDING_CONFIG.SWEEP_COIN && <SweepCoinTooltip handleClick={handleSweepClick} />}
        </Tooltip>
      </Overlay>
    );
  },
);
